import { IMapyBoxItem } from "~/interfaces";
import { node } from "~/util/dom";
import MyMapsMapyBoxItem from "../dialogs/mymaps-mapybox-item";
import { isPremiumNoteUser } from "~/util/user-note";
import createSDSIcon from "../icon";
import { MYMAPS_EDIT } from "../sds-compatible-icons";
import Tooltip, { ETooltipFlow, ETooltipPosition } from "../tooltip";
import { _ } from "~/i18n";

interface ICreateEditPropsBtn {
	likeData?: IMapyBoxItem;
	onSave?: (newLikeData: Partial<IMapyBoxItem>) => void;
}

export function createEditPropsBtn({
	likeData = null,
	onSave = () => {},
}: ICreateEditPropsBtn) {
	const editBtn = node("button", { className: "edit-props-btn" });
	const editBtnTooltip = node("p", { innerHTML: _("mymap.contextMenu.editProps") });
	let curLikeData: IMapyBoxItem = likeData;

	editBtn.appendChild(createSDSIcon({ className: "edit-props-btn-icon-edit", symbol: MYMAPS_EDIT }));

	const tooltip = new Tooltip({
		anchor: editBtn,
		trigger: editBtn,
		triggerEventType: "pointerenter",
		content: editBtnTooltip,
		arrow: false,
		flow: ETooltipFlow.CENTER,
		position: ETooltipPosition.TOP,
		offset: [2, 0, 0, 0],
		className: "usermarks-edit-tooltip",
		hideTimeout: 500,
	});

	editBtn.addEventListener("click", () => {
		if (curLikeData) {
			tooltip.hide();

			new MyMapsMapyBoxItem({
				mode: "edit",
				isPremiumUser: isPremiumNoteUser(),
				likeData: curLikeData,
				folder: {
					id: curLikeData.parent_id,
					title: curLikeData.parent_name,
				},
				onSave: ({ likeData: newLikeData }) => {
					onSave(newLikeData);
				},
			}).open();
		}
	});

	return {
		container: editBtn,
		show: () => {
			editBtn.classList.remove("hide");
		},
		hide: () => {
			editBtn.classList.add("hide");
		},
		setLikeData: (newLikeData: IMapyBoxItem) => {
			curLikeData = newLikeData;
		},
	};
}
